import compose from 'ramda/es/compose'
import omit from 'ramda/es/omit'
import pick from 'ramda/es/pick'
import reject from 'ramda/es/reject'
import { devMode } from '../../util/env'
import { buildQueryString } from '../../util/string'
import { NONCE } from '../../shared/constants'

export const ADD_SEARCH_AGENT = 'ksk001/searchAgent/ADD_SEARCH_AGENT'
export const ADD_SEARCH_AGENT_SUCCESS =
  'ksk001/searchAgent/ADD_SEARCH_AGENT_SUCCESS'
export const ADD_SEARCH_AGENT_FAILURE =
  'ksk001/searchAgent/ADD_SEARCH_AGENT_FAILURE'
export const EDIT_SEARCH_AGENT = 'ksk001/searchAgent/EDIT_SEARCH_AGENT'
export const EDIT_SEARCH_AGENT_SUCCESS =
  'ksk001/searchAgent/EDIT_SEARCH_AGENT_SUCCESS'
export const EDIT_SEARCH_AGENT_FAILURE =
  'ksk001/searchAgent/EDIT_SEARCH_AGENT_FAILURE'
export const GET_SEARCH_AGENTS = 'ksk001/searchAgent/GET_SEARCH_AGENTS'
export const GET_SEARCH_AGENTS_SUCCESS =
  'ksk001/searchAgent/GET_SEARCH_AGENTS_SUCCESS'
export const GET_SEARCH_AGENTS_FAILURE =
  'ksk001/searchAgent/GET_SEARCH_AGENTS_FAILURE'
export const REMOVE_SEARCH_AGENT = 'ksk001/searchAgent/REMOVE_SEARCH_AGENT'
export const REMOVE_SEARCH_AGENT_SUCCESS =
  'ksk001/searchAgent/REMOVE_SEARCH_AGENT_SUCCESS'
export const REMOVE_SEARCH_AGENT_FAILURE =
  'ksk001/searchAgent/REMOVE_SEARCH_AGENT_FAILURE'

export const initialState = {
  data: [],
  error: null,
  isLoading: false,
  isAdding: false,
  isEditing: false,
  isRemoving: false,
}

export default (state = initialState, action) => {
  const { type, payload } = action

  switch (type) {
    case ADD_SEARCH_AGENT:
      return {
        ...state,
        isAdding: true,
      }
    case ADD_SEARCH_AGENT_SUCCESS:
      return {
        ...state,
        isAdding: false,
        data: [...state.data, payload],
      }
    case ADD_SEARCH_AGENT_FAILURE:
      return {
        ...state,
        isAdding: false,
        error: payload.error,
      }
    case EDIT_SEARCH_AGENT:
      return {
        ...state,
        isEditing: true,
      }
    case EDIT_SEARCH_AGENT_SUCCESS:
      return {
        ...state,
        isEditing: false,
        data: state.data.map(item => (item.id === payload.id ? payload : item)),
      }
    case EDIT_SEARCH_AGENT_FAILURE:
      return {
        ...state,
        isEditing: false,
        error: payload.error,
      }
    case GET_SEARCH_AGENTS:
      return {
        ...state,
        isLoading: true,
      }
    case GET_SEARCH_AGENTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: payload,
      }
    case GET_SEARCH_AGENTS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      }
    case REMOVE_SEARCH_AGENT:
      return {
        ...state,
        isRemoving: true,
      }
    case REMOVE_SEARCH_AGENT_SUCCESS:
      return {
        ...state,
        isRemoving: false,
        data: reject(d => d.id === payload.id)(state.data),
      }
    case REMOVE_SEARCH_AGENT_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      }
    default:
      return state
  }
}

const toOmitByVermarktungart = {
  kauf: ['mietpreis'],
  miete: ['kaufpreis'],
}

export const addSearchAgent = () => (dispatch, getState) => {
  const state = getState()
  const filters = state.estateOverviewFilters

  const query = buildQueryString({
    ...compose(
      pick([
        'vermarktungsart',
        'perimeter',
        'location',
        'objektart',
        'wohnflaeche',
        'kaufpreis',
        'mietpreis',
        'zimmer',
      ]),
      omit(toOmitByVermarktungart[filters.vermarktungsart])
    )(filters),
  })

  dispatch({
    type: ADD_SEARCH_AGENT,
  })

  return fetch(`/wp-json/dhsv/v1/search-agent/add?${query}`, {
    headers: {
      'X-WP-Nonce': NONCE,
    },
  })
    .then(response => {
      if (![200, 400].includes(response.status)) {
        const message = response.statusText
          ? response.statusText
          : response.status

        throw new Error(message)
      }

      return response.json().then(json => {
        if ('id' in json) {
          dispatch({
            payload: json,
            type: ADD_SEARCH_AGENT_SUCCESS,
          })
        }

        return json
      })
    })
    .catch(error => {
      if (devMode) console.error(error) //eslint-disable-line
      dispatch({
        payload: {
          error: error,
        },
        type: ADD_SEARCH_AGENT_FAILURE,
      })
      throw error
    })
}

export const editSearchAgent = filters => dispatch => {
  const query = buildQueryString({
    ...filters,
  })

  dispatch({
    type: EDIT_SEARCH_AGENT,
  })

  return fetch(`/wp-json/dhsv/v1/search-agent/edit?${query}`, {
    headers: {
      'X-WP-Nonce': NONCE,
    },
  })
    .then(response => {
      if (![200, 400].includes(response.status)) {
        const message = response.statusText
          ? response.statusText
          : response.status

        throw new Error(message)
      }

      return response.json().then(json => {
        if ('id' in json) {
          dispatch({
            payload: json,
            type: EDIT_SEARCH_AGENT_SUCCESS,
          })
        }

        return json
      })
    })
    .catch(error => {
      if (devMode) console.error(error) //eslint-disable-line
      dispatch({
        payload: {
          error: error,
        },
        type: EDIT_SEARCH_AGENT_FAILURE,
      })
      throw error
    })
}

export const getSearchAgents = () => dispatch => {
  dispatch({
    type: GET_SEARCH_AGENTS,
  })

  return fetch(`/wp-json/dhsv/v1/search-agent/get`, {
    headers: {
      'X-WP-Nonce': NONCE,
    },
  })
    .then(response => {
      if (![200, 400].includes(response.status)) {
        const message = response.statusText
          ? response.statusText
          : response.status

        throw new Error(message)
      }

      return response.json().then(json => {
        dispatch({
          payload: json,
          type: GET_SEARCH_AGENTS_SUCCESS,
        })

        return json
      })
    })
    .catch(error => {
      if (devMode) console.error(error) //eslint-disable-line
      dispatch({
        payload: {
          error: error,
        },
        type: GET_SEARCH_AGENTS_FAILURE,
      })
      throw error
    })
}

export const removeSearchAgent = id => dispatch => {
  dispatch({
    type: REMOVE_SEARCH_AGENT,
  })

  const query = buildQueryString({
    id,
  })

  return fetch(`/wp-json/dhsv/v1/search-agent/remove?${query}`, {
    headers: {
      'X-WP-Nonce': NONCE,
    },
  })
    .then(response => {
      if (![200, 400].includes(response.status)) {
        const message = response.statusText
          ? response.statusText
          : response.status

        throw new Error(message)
      }

      return response.json().then(json => {
        if (json.success) {
          dispatch({
            payload: json,
            type: REMOVE_SEARCH_AGENT_SUCCESS,
          })
        }

        return json
      })
    })
    .catch(error => {
      if (devMode) console.error(error) //eslint-disable-line
      dispatch({
        payload: {
          error: error,
        },
        type: REMOVE_SEARCH_AGENT_FAILURE,
      })
      throw error
    })
}
